<template>
  <div class="c-resource-content">
    <el-tabs v-model="activeName" class="i-tab--sm">
      <el-tab-pane
        :label="item.label"
        :name="item.name"
        v-for="item in tabList"
        :lazy="item.name==='KnowledgeChart' || item.name === 'TopicResource'"
        :key="item.name">
          <component
            :is="item.component"
            :ref= "item.name"
            :data="knowledgeList"
            :edges="edges"
            :subject-id="subjectId"
            :course="data" />
        </el-tab-pane>
       <el-backtop
        v-if="isPad" target=".f-main" :visibility-height="50"></el-backtop>
    </el-tabs>
  </div>
</template>

<script>
import { getKnowledgeList } from '@/api/pt';
import KnowledgeChart from './knowledge-chart.vue';
import TopicResource from './topic-resource.vue';
import VideoLectures from './video-lectures.vue';
import { getSign } from '@/utils';

export default {
  name: 'ResourceContent',
  components: {
    KnowledgeChart,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    subjectId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      activeName: this.$route.query.tab || 'KnowledgeChart',
      isPad: this.$route.query.spad,
      tabList: [{
        label: '知识图谱',
        name: 'KnowledgeChart',
        component: KnowledgeChart,
      }, {
        label: '视频讲义',
        name: 'VideoLectures',
        component: VideoLectures,
      }, {
        label: '题目资源',
        name: 'TopicResource',
        component: TopicResource,
      }],
      knowledgeList: [],
    };
  },
  computed: {
    edges() {
      if (!this.knowledgeList || !this.knowledgeList.length) {
        return [];
      }
      return this.knowledgeList.reduce((prev, cur) => {
        if (!cur.pre_lo_list || !cur.pre_lo_list.length) {
          return prev;
        }
        return prev.concat(cur.pre_lo_list.map((item) => ({
          source: item,
          target: cur.id,
        })));
      }, []);
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(course) {
        this.getKnowledgeList(course);
      },
    },
    activeName(v) {
      if (v === 'VideoLectures') {
        this.$refs.VideoLectures[0].cancelPreview();
      }
    },
  },
  methods: {
    getKnowledgeList(course) {
      console.log({ course });
      if (!course || !course.chapterId || !course.lessonId || !course.courseId) {
        return null;
      }
      const param = {
        chapter_id: course.chapterId,
        lesson_id: course.lessonId,
        textbook_id: course.textbookId,
        course_id: course.courseTreeId,
      };
      param.sign = getSign(param);
      return getKnowledgeList(param).then((res) => {
        if (res.code === 200) {
          this.knowledgeList = res.data.map((item) => {
            let category = '低考频';
            if (item.weight_level >= 60) {
              category = '高考频';
            } else if (item.weight_level >= 30) {
              category = '中考频';
            }
            return {
              ...item,
              id: item.knowledge_code,
              name: item.knowledge_name,
              category,
            };
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-resource-content {
  width: 100%;
}
.i-tab--sm {
  /deep/ {
    .el-tabs__nav-scroll {
      padding-left: 24px;
    }
    .el-tabs__item {
      font-size: 16px;
      padding: 0 8px !important;
      margin: 0 !important;
      width: 160px !important;
    }
    .el-tabs__active-bar {
      left: 30px !important;
    }
    .el-tabs__active-bar::after {
      display: none;
    }
  }
}
</style>
